<template lang="pug">
    .questionnaire-uvas
        app-text-field.result-field(
            v-model="result"
            label="UVAS"
            is-number
            :max="50"
            :error="error"
            :disabled="disabled"
        )

        app-link(
            @click="openModal"
            :disabled="disabled"
        ) Рассчитать

        questionnaire-modal(ref="modal")
            .title Шкала активности уртикарного васкулита (UVAS)

            .block(v-for="(block, blockIndex) in blocks" :key="blockIndex")
                .block__name(v-html="block.name")
                .block-choices.app-choice-group(v-for="(question, id) in block.questions" :key="id")
                    .block-question__name {{id}}. {{ question.name }}
                    .app-choice-group__list
                        app-choice(
                            v-for="variant in variants"
                            v-model="question.value"
                            type="radio"
                            :label="variant.name"
                            :radio-value="variant.value"
                            :error="$v.$dirty && $v.blocks.$each.$iter[blockIndex].questions.$each.$iter[id].value.$invalid"
                        )

            .bottom
                .result(v-if="tempResult !== null") UVAS = <b>{{ tempResult }}</b>
                app-button(
                    large
                    @click="calculate"
                ) Рассчитать
                app-button(
                    large
                    color="white"
                    :disabled="tempResult === null"
                    @click="save"
                ) Сохранить рассчет
</template>

<script>
import questionnaireMixin from '@/mixins/questionnaireMixin';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'questionnaire-uvas',

    mixins: [questionnaireMixin],

    data: () => ({
        blocks: [
            {
                name: 'Пожалуйста, оцените интенсивность ваших симптомов за&nbsp;последние 7&nbsp;дней по&nbsp;шкале от&nbsp;0 до&nbsp;10. <br/><br/>',
                questions: {
                    1: { name: 'Высыпания (волдыри)' },
                    2: { name: 'Жжение/зуд' },
                    3: { name: 'Остаточная пигментация кожи' },
                    4: { name: 'Боль в суставах' },
                    5: { name: 'Общие симптомы (слабость, утомляемость, озноб, жар)' },
                },
            },
        ],

        variants: [
            { name: '0', value: 0 },
            { name: '1', value: 1 },
            { name: '2', value: 2 },
            { name: '3', value: 3 },
            { name: '4', value: 4 },
            { name: '5', value: 5 },
            { name: '6', value: 6 },
            { name: '7', value: 7 },
            { name: '8', value: 8 },
            { name: '9', value: 9 },
            { name: '10', value: 10 },
        ],
    }),

    validations: {
        blocks: {
            $each: {
                questions: {
                    $each: {
                        value: { required },
                    },
                },
            },
        },
    },

    created() {
        this.blocks.forEach(block => {
            for (let id in block.questions) {
                this.$set(block.questions[id], 'value', null);
            }
        });
    },

    methods: {
        calculate() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                this.$refs.modal.scrollToInvalidField();
                return;
            }

            this.tempResult = this.blocks.reduce((sum, block) => {
                return sum + Object.values(block.questions).reduce((sumB, question) => sumB + question.value, 0);
            }, 0);
        },
    },
};
</script>

<style scoped lang="scss">
.questionnaire-uvas {
    .result-field {
        width: rem(76px);
    }

    @include mobile_or_P {
        .result-field {
            width: rem(200px);
            margin-right: 1.5rem;
        }

        .block-choices {
            width: 100%;

            .app-choice {
                margin-right: 0;
            }
        }
    }
}
</style>
